import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  truncatedText: {
    cursor: 'pointer'
  },
  tooltipLabel: {
    width: '100%'
  },
  tooltip: {
    backgroundColor: theme.colorPalette.green_75
  },
  tooltipList: {
    margin: 0,
    paddingLeft: theme.spacing(2)
  }
}));

export default useStyles;
